import PropTypes from 'prop-types';

const ChildrenPropType = PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]);

export default ChildrenPropType;

/**
 * @typedef {(JSX.Element|JSX.Element[])} ChildrenPropType
 */
